module.exports = __webpack_public_path__ + "img/h3.1ee752a7.svg";